<template>
  <v-container>
    <a
      @click="$router.go(-1)"
      class="ml-4"
    >&#8592;回上一頁</a>
    <h1 class="title pl-4 mt-6">基本資料</h1>
    <v-row>
      <v-col>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th
                  class="text-left"
                  style="width: 30%;"
                >項目</th>
                <th class="text-left">資料</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>地址/戶別</td>
                <td>{{ data.address }}</td>
              </tr>
              <tr>
                <td>描述</td>
                <td>{{ data.description }}</td>
              </tr>
              <tr>
                <td>客戶</td>
                <td>{{ data.clientName }}</td>
              </tr>
              <tr>
                <td>問題類別</td>
                <td>{{ data.problemType }}</td>
              </tr>
              <tr>
                <td>工地</td>
                <td>{{ data.site }}</td>
              </tr>
              <tr>
                <td>電話</td>
                <td>{{ data.phone }}</td>
              </tr>
              <tr>
                <td>Email</td>
                <td>{{ data.email }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-row v-if="data.customerImg">
      <v-col>
        <v-img
          :src="data.customerImg"
          alt=""
        ></v-img>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="d-flex justify-space-between">
        <v-btn
          v-if="!data.completed"
          text
          color="cyan darken-2"
          :to="`/edit/${this.$route.params.repair_id}`"
        >修改資料</v-btn>

        <v-btn
          v-if="!data.completed && isAdmin"
          text
          color="red"
          @click="deleteRepair"
        >刪除資料</v-btn>
      </v-col>
    </v-row>
    <v-card
      class="mt-3"
      v-if="data.repair_items"
    >
      <v-container>
        <v-flex xs12>
          <h4 class="h4">維修紀錄</h4>
        </v-flex>
        <v-flex
          xs12
          v-for="(repair_item, repairIndex) in data.repair_items"
          :key="repairIndex"
        >
          <v-layout
            mt-3
            mb-1
          >
            <span class="mr-auto">維修: {{ repairIndex + 1 }} </span>
            <span class="date">{{
                repair_item.date
                  .toDate()
                  .toISOString()
                  .slice(0, 10)
              }}
              | {{ repair_item.date.toDate().getHours() }}:{{
                repair_item.date.toDate().getMinutes() > 9
                  ? repair_item.date.toDate().getMinutes()
                  : "0" + repair_item.date.toDate().getMinutes()
              }}
            </span>
          </v-layout>
          <v-layout mb-1> 描述: {{ repair_item.description }} </v-layout>
          <v-layout mb-1>
            <span v-if="repair_item.currentUser">填寫人 {{ repair_item.currentUser }}</span>
          </v-layout>
          <v-row>
            <v-col
              v-for="(image, index) in repair_item.images"
              :key="index"
            >
              <v-img
                :src="image.imageUrl"
                alt=""
              ></v-img>
            </v-col>
          </v-row>

          <v-layout
            my-4
            justify-end
            v-if="!data.completed"
          >
            <v-btn
              outlined
              color="error"
              v-on:click="deleteItem(repairIndex)"
            >刪除</v-btn>
          </v-layout>
          <hr />
        </v-flex>
      </v-container>
    </v-card>
    <h1
      class="title pl-4"
      v-if="data.completed"
    >完工資料</h1>
    <v-row>
      <v-col>
        <v-img
          :src="data.finishedImage"
          alt=""
        ></v-img>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-img
          :src="data.signatureImage"
          alt=""
        ></v-img>
      </v-col>
    </v-row>
    <v-row v-if="data.completed">
      <v-col>
        <h4 class="h4">簽收</h4>
        <p>填寫人 {{ data.finishedCurrentUser }}</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="d-flex justify-space-between">
        <div class="my-2">
          <v-btn
            :to="`/show/${this.$route.params.repair_id}/new-item`"
            depressed
            outlined
            color="blue-grey  darken-2"
          >新增維護紀錄</v-btn>
        </div>
        <div class="my-2">
          <v-btn
            v-if="!data.completed && data.repair_items.length > 0"
            :to="`/finish/${this.$route.params.repair_id}`"
            depressed
            color="blue-grey  white--text"
          >完工簽名</v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src
import { repairsCollection } from "@/db";
import firebase from "firebase";

export default {
  name: "Show",
  data: () => ({
    data: {
      id: "",
      site: "",
      description: "",
      address: "",
      phone: "",
      currentUser: "",
      clientName: "",
      problemType: "",
      customerFilePath: ""
    },
    currentUserEmail: ""
  }),
  created() {
    repairsCollection
      .doc(this.$route.params.repair_id)
      .get()
      .then(doc => {
        if (doc.exists) {
          this.data = {
            ...this.data,
            ...doc.data(),
            id: this.$route.params.repair_id
          };
        } else {
          // eslint-disable-next-line no-console
          console.log("No such document!");
        }
      });
  },
  methods: {
    deleteItem(deleteId) {
      const vm = this;
      this.$swal({
        text: "你確定要刪除嗎",
        showCancelButton: true,
        confirmButtonText: "確定",
        cancelButtonText: "取消"
      }).then(result => {
        if (result.value) {
          Promise.all(
            vm.data.repair_items[deleteId].images.map(
              async image => await vm.deleteImg(image.filePath)
            )
          )
            .then(response => {
              // File deleted successfully
              console.log(response);
              repairsCollection
                .doc(vm.$route.params.repair_id)
                .update({
                  repair_items: vm.data.repair_items.filter(
                    (repair_item, index) => index !== deleteId
                  )
                })
                .then(docRef => {
                  // eslint-disable-next-line no-console
                  console.log("docRef", docRef);
                  vm.$router.go();
                })
                // eslint-disable-next-line no-console
                .catch(error => console.log(error));
            })
            .catch(function(error) {
              console.log(error);
              // Uh-oh, an error occurred!
            });
        }
      }),
        function() {
          // 取消要做的事
        };
    },
    deleteRepair() {
      const vm = this;
      this.$swal({
        text: "你確定要刪除嗎",
        showCancelButton: true,
        confirmButtonText: "確定",
        cancelButtonText: "取消"
      }).then(function(result) {
        if (result.value) {
          if (vm.data.customerFilePath) {
            vm.deleteImg(vm.data.customerFilePath).then(response => {
              console.log(response);
              repairsCollection
                .doc(vm.$route.params.repair_id)
                .delete()
                .then(function() {
                  // eslint-disable-next-line no-console
                  console.log("Document successfully deleted!");
                  vm.$router.push("/");
                })
                .catch(function(error) {
                  // eslint-disable-next-line no-console
                  console.error("Error removing document: ", error);
                });
            });
          } else {
            repairsCollection
              .doc(vm.$route.params.repair_id)
              .delete()
              .then(function() {
                // eslint-disable-next-line no-console
                console.log("Document successfully deleted!");
                vm.$router.push("/");
              })
              .catch(function(error) {
                // eslint-disable-next-line no-console
                console.error("Error removing document: ", error);
              });
          }
        }
      });
    },
    deleteImg(filePath) {
      const storageRef = firebase
        .storage()
        .ref(`/${this.$route.params.repair_id}/`);
      // Create a reference to the file to delete
      var desertRef = storageRef.child(filePath);

      return new Promise((resolve, reject) => {
        desertRef
          .delete()
          .then(function(data) {
            // File deleted successfully
            resolve(data);
          })
          .catch(error => {
            console.log("delete Img failed", error);
            reject(error);
          });
      });
    }
  },
  updated() {
    if (firebase.auth().currentUser) {
      this.currentUserEmail = firebase.auth().currentUser.email;
    }
  },
  computed: {
    isAdmin() {
      return this.currentUserEmail === "manager@gmail.com";
    }
  }
};
</script>
